import type { ScreenerReqSegments } from '@revelio/data-access';

import { FilterId } from '../../types/filters';

/**
 * Map segment field name (key of ScreenerReqSegments) to FilterId.
 * Reverse of mapFilterIdToSegmentField in get-screener-filters.ts.
 */
const segmentFieldToFilterId: Partial<
  Record<keyof ScreenerReqSegments, FilterId>
> = {
  attrition: FilterId.ATTRITION_RATE,
  growth_yoy: FilterId.GROWTH_RATE,
  hiring: FilterId.HIRING_RATE,
  headcount: FilterId.HEADCOUNT,
  salary: FilterId.SALARY,
  tenure: FilterId.TENURE,
  inflow: FilterId.INFLOW,
  outflow: FilterId.OUTFLOW,
};

export const getFilterIdForSegmentField = (
  segmentField: keyof ScreenerReqSegments
): FilterId | null => segmentFieldToFilterId[segmentField] ?? null;

/**
 * Map segment people filter keys (inside segment.filter) to FilterId and type.
 * Used when converting resolved segment filters to CustomDash segmentations.
 */
export const segmentFilterKeyToFilterId: Partial<
  Record<string, { filterId: FilterId; type: 'tree' | 'list' }>
> = {
  geography: { filterId: FilterId.GEOGRAPHY, type: 'tree' },
  industry: { filterId: FilterId.INDUSTRY, type: 'tree' },
  role: { filterId: FilterId.ROLE, type: 'tree' },
  seniority: { filterId: FilterId.SENIORITY, type: 'list' },
  highest_degree: { filterId: FilterId.EDUCATION, type: 'list' },
  gender: { filterId: FilterId.GENDER, type: 'list' },
  ethnicity: { filterId: FilterId.ETHNICITY, type: 'list' },
};

/**
 * Segment metric FilterIds that use percentage (rate) values in the API.
 * API sends decimal (e.g. 0.05); we display and store as percentage (5).
 */
export const RATE_SEGMENT_FILTER_IDS = new Set<FilterId>([
  FilterId.ATTRITION_RATE,
  FilterId.GROWTH_RATE,
  FilterId.HIRING_RATE,
]);
